//#region src/module/types/index.ts
/**
* Type guard for undefined types
*/
function isDefined(v) {
	return !(typeof v === "undefined");
}
/**
* Type guard for falsy types
*/
function isTruthy(v) {
	return Boolean(typeof v !== "undefined" && v !== null && v);
}
/**
* Type guard for non-null types
*/
function isNotNull(v) {
	return v !== null;
}
/**
* Type guard for if a (string or number) key exists in an object
*
* Will return the key type to be `keyof` your object
*/
function keyInObject(key, obj) {
	return Boolean(typeof obj === "object" && obj && (typeof key === "string" || typeof key === "number") && key in obj);
}

//#endregion
export { isDefined, isNotNull, isTruthy, keyInObject };